<div class="container container-narrow">
    <h2>One moment please</h2>
    <p *ngIf="(complete$ | async) == false">
        Waiting for payment to clear.<br/>
        <br/>
        <b>Do not navigate away from this page!</b>
    </p>
    <p *ngIf="(complete$ | async) == true">
        Payment complete!
        <br />
        <br />
        <a href="{{dashboardUrl}}" class="btn"><i class="fa fa-grip"></i> Back To Your dashboard</a>
    </p>
    <div *ngIf="error$ | async as error" class="error-message-box">
        <i class="fa fa-exclamation-triangle"></i> {{ error }}<br />
        <br />
        <a href="{{dashboardUrl}}" class="btn"><i class="fa fa-grip"></i> Back To Your dashboard</a>
    </div>
    <div class="loader-container">
        <loader-component *ngIf="loading$ | async"></loader-component>
    </div>
</div>

